import { PopoverProps } from '@arco-design/web-react';
import React, { useCallback, useMemo } from 'react';
import { IconFont } from '@bay-email/editor';
import { ToolItem } from '../ToolItem';
import { useTiptapEditor } from '../Tools/TiptapEditorContext';
import { EMAIL_BLOCK_CLASS_NAME } from '@bay-email/core';

export interface LinkProps extends PopoverProps {
	currentRange: Range | null | undefined;
	onChange: () => void;
}

function getItalicNode(node: Node | null | undefined): Element | null {
	if (!node) return null;
	if (node instanceof Element && node.classList.contains(EMAIL_BLOCK_CLASS_NAME))
		return null;
	if (node instanceof Element && node.tagName.toLocaleLowerCase() === 'i') return node;
	return getItalicNode(node.parentNode);
}

export function Italic(props: LinkProps) {
	const { onChange } = props;
	const editor = useTiptapEditor();
	const node = useMemo(() => {
		return getItalicNode(props.currentRange?.commonAncestorContainer);
	}, [props.currentRange]);

	const onClick = useCallback(() => {
		// Don't change the selection - just apply the formatting
		onChange();
	}, [onChange]);

	return (
		<ToolItem
			title={t('Italic')}
			isActive={editor ? editor.isActive('italic') : Boolean(node)}
			icon={<IconFont iconName='icon-italic' />}
			onClick={onClick}
		/>
	);
}
